<template>
  <div class="Essay">
    <precautions
      v-if="selectedStep === 0 && questionData"
      :title="questionData.Name"
      :level="level"
      :unit="unit || currentName"
    />

    <!-- START -->
    <div class="d-flex justify-content-center mt-3" v-if="selectedStep === 0">
      <a class="btn gept_main_bg4 text-white px-5 py-2 rounded-pill font-weight-bold"
        @click="getStart()"
      >
        {{ $t('GEPT.common.start') }}
      </a>
    </div>

    <!-- 作答區 -->
    <div v-if="selectedStep === 1 && qData && qData.length > 0" class="Essay_inner p-2">
      <ImageOCRPopup :visible.sync="show" v-on:submitText="submitText" />
      <div v-for="(item, index) in qData" :key="index">
      <!-- 上方說明 -->
      <div class="d-flex justify-content-between align-items-center bg-white mb-2 essay-toolbar">
        <div class="d-flex align-items-center p-2">
          <h6 class="font-semibold mb-0 text-left description-text"
          >
            {{ writingDescription }}
          </h6>
        </div>

        <div class="d-flex align-items-center p-2">
          <div class="p-2 border-1 border-2 rounded m-1 gept_main_color10 border_main10 font-semibold whitespace-no-wrap essay-counter">
            {{ $t('GEPT.common.wordsCount', { count: textLength(item.Answer) }) }}
          </div>
          <div class="p-2 border-1 border-2 rounded m-1 gept_main_color4 border_main2 font-semibold essay-timer" v-if="$route.name !== 'quiz_practice_speaking'">
            {{ formatTime(answer_count) }}
          </div>
        </div>
      </div>

      <!-- 題目 + 作答 -->
      <div class="writing_inner mb-3">
        <div class="row essay-workspace" >
          <!-- 題目 -->
          <div class="col-md-6 p-2 essay-prompt-column">
            <div class="bg-white rounded h-100 overflow-hidden essay-prompt-card">
              <div class="d-flex align-items-center justify-content-between gept_main_bg7">
                <a @click="showUploadImg(index)" class="btn-deny m-2 d-inline-block pointer" v-if="$route.path.includes('quiz')">{{ $t('GEPT.writing.uploadImage') }}</a>
                <p class="text-white text-center p-2 h5 font-weight-bold flex-fill mb-0">
                  {{ $t('GEPT.writing.questionTitle') }}
                </p>
                <a v-if="getQuestionExplain(item)" class="p-2 cursor-pointer" @click="alertTips(item)">
                  <img src="@/assets/image/gept/tips2.png" class="img-fluid" />
                </a>
              </div>

              <div class="p-4 h-100 essay-prompt-body">
                <div class="mb-4 essay-title-block">
                  <p class="h5 font-weight-semibold text-left essay-title">{{ item.Title }}</p>
                </div>
                <div class="essay-image-wrap">
                  <img :src="item.ImageUrl" class="img-fluid d-block essay-image" />
                </div>
              </div>
            </div>
          </div>

          <!-- 作答框 -->
          <div class="col-md-6 p-2 essay-answer-column">
            <textarea
              v-model="item.Answer"
              :disabled="!isCanActive"
              rows="15"
              class="form-control bg-white p-4 font-weight-semibold essay-textarea"
              :placeholder="$t('GEPT.writing.placeholderAnswer')"
            ></textarea>
          </div>
        </div>
      </div>
      </div>
      <!-- 底部按鈕 -->
      <div class="d-flex justify-content-center essay-actions">
        <!-- <a @click="show = true" class="btn-deny m-2 d-inline-block pointer" v-if="currentName === '英文作文' && $route.path.includes('quiz')">上傳圖片</a> -->
        <a class="btn-default gept_main_bg4 text-white m-2 d-inline-block pointer"
          @click="clearAnswer()">
          {{ $t('GEPT.writing.clearAnswer') }}
        </a>
        <a class="btn-default gept_main_bg5 text-white m-2 d-inline-block pointer"
          @click="toggleReport()">
          {{ geptNextActionLabel(!isLastGroup && ($route.name === 'formal_exam' || $route.name === 'quiz_practice_speaking')) }}
        </a>
      </div>
    </div>
  </div>
</template>


<script>
  import precautions from '@/components/AiHelper/GEPT/precautions'
  import allJs from '@/components/AiHelper/all.js'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  import ImageOCRPopup from '@/components/AiHelper/speech/ImageOCRPopup.vue'
  import geptI18n from '@/components/AiHelper/GEPT/i18n'
  export default {
    name: 'Essay',

    data () {
      return {
        showfirstModal: false,
        isShowTitle: false,
        isCanActive: false, // 可以動作

        selectedStep: 0,
        questionNumber: 0, //第幾題

        timer: null,

        // 回答
        answer_count: 8,

        qData: null,
        spellCheck: null,
        show: false,

        selectedIndex: null
      }
    },
    mixins: [
      allJs,
      formal_examJs,
      geptI18n
    ],
    props: {
      questionData: {
        type: Array
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      },
      currentName: {
        type: String
      }
    },
    components: {
      precautions,
      ImageOCRPopup
    },
    computed: {
      partDescription () {
        let part = Array.isArray(this.questionData) ? this.questionData[0] : this.questionData
        if (!part) return ''

        return part.Description || part.description || ''
      },

      writingDescription () {
        let currentWritingType = this.unit || this.currentName

        if (this.partDescription) return this.partDescription

        if (this.$route.name === 'quiz_practice_speaking') {
          if (currentWritingType === '中譯英') {
            return this.$t('GEPT.writing.translateDescription')
          }

          if (currentWritingType === '英文作文') {
            return this.$t('GEPT.writing.compositionDescription')
          }
        }

        return this.$t('GEPT.writing.paragraphDescription')
      }
    },
    methods: {
      clearAnswer () {
        for (let value of this.qData) {
          value.Answer = null
        }
      },
      getStart () {
        this.setArray()
        this.selectedStep = 1
        this.isCanActive = true
        this.$route.name !== 'quiz_practice_speaking' ? this.stopWatch() : null
      },

      setArray () {
        let part = Array.isArray(this.questionData) ? this.questionData[0] : this.questionData
        this.qData = part && Array.isArray(part.Questions) ? part.Questions : []
      },

      stopWatch () {
        this.timer = setInterval(() => {
            this.answer_count++

            if (this.answer_count >= 1 * 60 * 60) {
              clearInterval(this.timer)
              this.isCanActive = false
            }
          }, 1000
        )
      },

      formatTime (seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60

        const formattedTime = [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':')

        return formattedTime
      },

      getQuestionExplain (item) {
        if (!item) return ''
        return item.explain || item.Explain || item.explanation || item.Explanation || ''
      },

      formatAlertHtml (text) {
        return String(text)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/\r?\n/g, '<br>')
      },

      alertTips (item) {
        let explain = this.getQuestionExplain(item)
        return this.$swal.fire({
          title: this.$t('GEPT.alerts.answerHint'),
          html: explain ? this.formatAlertHtml(explain) : '',
          showCloseButton: true,
          showConfirmButton: false,
          focusConfirm: false,
          showDenyButton: false,
          customClass: {
            container: '',
            popup: 'p-0 max-w-3xl w-100',
            header: 'py-2 text-white gept_main_bg',
            title: 'text-white m-0 text-2xl py-2',
            closeButton: 'top-0 right-0 position-absolute',
            htmlContainer: 'p-4 font-bold leading-loose mb-6 text-left',
            actions: 'mb-4 mt-5',
            confirmButton: 'submitButton-gept',
            denyButton: 'denyButton-gept',
          }
        })
      },

      replaceString(item, index) {
        for (let value of this.spellCheck) {
          if (index >= value.offset && index < value.offset + value.token.length) {
            return true
          }
        }
        return false
      },
      textLength (string) {
        if (string) {
          let words = string.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
          let wordCount = words.filter(word => word.length > 0).length
          return wordCount
        }
        return 0
      },
      async toggleReport () {
        // eslint-disable-next-line
        let isGuideLink =  (this.isLastGroup && this.$route.name === 'quiz_practice_speaking') || (this.isLastGroup && this.$route.name === 'formal_exam') || (this.$route.name === 'practice_speaking') ? true : false
        let allAnswersFilled = this.qData.every(section => section.Answer.trim() !== "")

        if (allAnswersFilled) {
          if (this.$route.name === 'practice_speaking' && await this.checkSubmitReport(this.unitTitle, this.questionData.Name)) {
            this.finish_exams(this.$route.query.record_id, this.questionData.Name, isGuideLink)
          } else if (this.$route.name === 'formal_exam' || this.$route.name === 'quiz_practice_speaking') {
            for (let value of this.qData) {
              let qId = value.Id
              let Answer = value.Answer
              await this.post_gept_records_byFormal(this.$route.query.record_id, qId, this.currentName, Answer, null)
            }
            this.$nextTick(() => {
              if (!this.isLastGroup) {
                this.$emit('guideNextType')
              } else {
                this.post_gept_records_finish(this.$route.query.record_id)
              }
            })
          }
        } else {
          this.finish_error_swal()
        }
      },
      showUploadImg (index) {
        this.selectedIndex = index
        this.show = true
      },
      submitText (payload) {
        this.qData[this.selectedIndex].Answer += payload
        this.selectedIndex = null
      }
    }
  }
</script>

<style lang="scss" scoped>
.Essay {
  .Essay_inner {
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }

    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    .item_text {
      min-height: 120px;
      height: 20%;
    }
    .description-text {
      white-space: pre-line;
    }
    .essay-toolbar {
      gap: 0.5rem;
    }
    .essay-counter,
    .essay-timer {
      white-space: nowrap;
    }
    .essay-title {
      line-height: 1.5;
      overflow-wrap: anywhere;
    }
    .essay-image-wrap {
      text-align: center;
    }
    .essay-image {
      margin: 0 auto;
      max-height: 520px;
      object-fit: contain;
    }
    .essay-textarea {
      line-height: 1.55;
      resize: vertical;
    }
    .essay-actions {
      gap: 0.75rem;
      flex-wrap: wrap;
    }

    @media (max-width: 767.98px) {
      .essay-toolbar {
        align-items: flex-start !important;
        flex-wrap: wrap;
        padding: 0.75rem;
      }
      .essay-toolbar h6 {
        font-size: 1rem;
        line-height: 1.65;
      }
      .essay-counter,
      .essay-timer {
        font-size: 0.95rem;
      }
      .writing_inner {
        margin-bottom: 1rem !important;
      }
      .essay-workspace {
        display: block;
        margin-left: 0;
        margin-right: 0;
      }
      .essay-prompt-column,
      .essay-answer-column {
        padding: 0.4rem 0 !important;
      }
      .essay-prompt-card {
        height: auto !important;
      }
      .essay-prompt-body {
        padding: 1rem !important;
      }
      .essay-title-block {
        margin-bottom: 1rem !important;
      }
      .essay-title {
        font-size: 1.05rem;
        line-height: 1.55;
      }
      .essay-image {
        max-height: 460px;
        max-width: 100%;
      }
      .essay-textarea {
        min-height: 320px;
        padding: 1rem !important;
        font-size: 1rem;
      }
      .essay-actions {
        gap: 0.75rem;
        padding-bottom: 0.5rem;
      }
      .essay-actions .btn-default {
        flex: 1 1 0;
        min-width: 135px;
        max-width: 220px;
        padding-left: 1rem;
        padding-right: 1rem;
        text-align: center;
        white-space: normal;
        line-height: 1.35;
      }
    }
  }
}
</style>
